<template>
    <v-app>
        <v-container fluid id="login">
            <v-row no-gutters>
                <v-col cols="3" class="main-part d-none d-md-none d-lg-flex">
                    <div class="d-flex">
                        <v-img src="@/assets/sygnali_logo_450.png" contain class="img-logo-left-size"></v-img>
                        <span class="span-logo-color">PLATFORMA OCHRONY SYGNALISTÓW</span><br /><br />
                        <v-card-text><p class="inbox-text-left">POBIERANIE PLIKÓW</p></v-card-text>
                    </div>
                </v-col>
                <v-col cols="12" lg="9" class="login-part d-flex align-center justify-center">
                    <v-row no-gutters class="align-start">
                        <v-col cols="12" class="login-part d-flex align-center justify-center flex-column">                   
                            <div>
                                <v-container style="max-width: 550px">
                                    <v-row class="flex-column">
                                        <p>Pliki udostępnione przez: <b>{{externalData.customerName}}</b></p>
                                        <p>Numer zgłoszenia: <b>{{externalData.messageId}}</b></p>
                                        <p>Czas wygaśnięcia dostępu: <b>{{externalData.linkLifeTime}}</b></p>
                                        <p>Limit 5 pobrań, wykorzystano: <b>{{externalData.downloadCount == null ? 0 : externalData.downloadCount}}</b></p>
                                        <p>Wygeneruj KOD który trafi na skrzynkę e-mail <b>{{externalData.email}}</b> w przeciągu kilku minut <v-btn @click="generatePin()" :disabled="downloadProcessing == true || generatePinProcessing == true">Generuj</v-btn></p>
                                        <p v-if="pinMessageInfo.length > 0 && pinMessageInfo.includes('Błąd')" style="color:red;">{{pinMessageInfo}}</p>
                                        <p v-if="pinMessageInfo.length > 0 && !pinMessageInfo.includes('Błąd')" style="color:green;">{{pinMessageInfo}}</p>
                                        <v-col cols="12" class="d-flex align-center my-8">
                                        </v-col>
                                        <div>
                                            <v-col>
                                                <v-text-field v-model="code"
                                                                label="Uzupełnij Kod"
                                                                hint="8 znaków - wielkość liter ma znaczenie"
                                                              style="width: 300px;"
                                                                required></v-text-field>

                                            </v-col>
                                            <v-col class="d-flex justify-space-between">
                                                <v-btn class="text-capitalize"
                                                        large
                                                        autocomplete="off"
                                                        :disabled="code.length != 8 || downloadProcessing == true"
                                                        color="primary"
                                                        @click="downloadFiles()">
                                                    Pobierz udostępnione pliki
                                                </v-btn>
                                            </v-col>
                                        </div>
                                    </v-row>
                                </v-container>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
    import Service from '@/services/Service'
  export default {
    name: 'External',
    data() {
      return {
          externalData: {},
          code: "",
          pinMessageInfo: "",
          downloadProcessing: false,
          generatePinProcessing: false,
      }
    },
    created(){
        document.title = "Sygnali.pl";
    },
    async mounted() {
        await this.getExternalData();
    },
    methods: {
        async downloadFiles() {
            try {
                if (this.code.length != 8)
                    return;

                var data = {
                    messadeId: this.externalData.messageId,
                    code: this.code
                };
                this.downloadProcessing = true;
                const result = await Service.downloadExternalFiles(data);
                if (result.status == 200) {
                    const contentType = result.headers['content-type'];
                    var a = document.createElement('a');
                    var blob = new Blob([result.data], { 'type': contentType });
                    a.href = window.URL.createObjectURL(blob);
                    a.download = "zgloszenie_" + this.externalData.messageId + "_files.zip";
                    a.click();
                }
                await this.getExternalData();
                this.downloadProcessing = false;
            } catch (e) {
                this.downloadProcessing = false;
                alert(e.response.status + " - Błąd podczas pobierania. Sprawdź poprawność kodu, limitu pobrań oraz czasu wygaśnięcia.");
                return;
            }
        },
        async generatePin() {
            try {
                this.generatePinProcessing = true;
                const result = (await Service.generateEmailPin(this.externalData.messageId)).data;
                if (result == true) {
                    this.pinMessageInfo = "KOD został poprawnie wygenerowany i wysłany.";
                }
                else {
                    this.pinMessageInfo = "Błąd podczas generowania KODu - spróbuj ponownie!";
                }
            } catch (e) {
                this.pinMessageInfo = "Błąd podczas generowania KODu - spróbuj ponownie!";
                alert(e.response.status + " - " + e.response.data.toString());
                return;
            }
            finally {
                this.generatePinProcessing = false;
            }
        },
        async getExternalData() {
            try {
                this.generatePinProcessing = true;
                const result = (await Service.getExternalData()).data;
                if (Object.keys(result).length > 0) {
                    this.externalData = result;
                }
            } catch (e) {
                alert(e.response.status + " - " + e.response.data.toString());
                return;
            }
            finally {
                this.generatePinProcessing = false;
            }
      }
    }
  }

</script>

<style src="../Login/Login.scss" lang="scss" />
